import type { CSSProperties } from 'react'

const GRADIENT = 'linear-gradient(135deg, #3B4CCA 0%, #7C5CD3 100%)'
const SHADOW_BRAND = '0 4px 14px rgba(59,76,202,.35)'
const SHADOW_SOFT = '0 1px 2px rgba(31,26,46,.04), 0 12px 28px rgba(31,26,46,.06)'

export { GRADIENT, SHADOW_BRAND, SHADOW_SOFT }

/** Uppercase section eyebrow used across every account tab. */
export const EYEBROW_STYLE: CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--muted)',
}

/** Short denomination labels for compact rails. */
export const DENOM_SHORT: Record<string, string> = {
  'seventh-day-adventist': 'Adventist',
  baptist: 'Baptist',
  methodist: 'Methodist',
  'non-denominational': 'Non-denom.',
  catholic: 'Catholic',
  lutheran: 'Lutheran',
  presbyterian: 'Presbyterian',
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diff / 60_000)
  if (mins < 60) return `${mins}m`
  const hours = Math.floor(diff / 3_600_000)
  if (hours < 24) return `${hours}h`
  const days = Math.floor(diff / 86_400_000)
  if (days === 1) return 'Yest.'
  return `${days}d`
}
